import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=02aba750&scoped=true&"
import script from "./combination.vue?vue&type=script&lang=js&"
export * from "./combination.vue?vue&type=script&lang=js&"
import style0 from "./combination.vue?vue&type=style&index=0&id=02aba750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aba750",
  null
  
)

export default component.exports